import { request } from 'apis/request';
import urls from 'apis/configure/urls';

const { apiUrlV1 } = urls;

class MerchandisePromotionService {
  static fetch(originParams) {
    const params = {
      ...{ page_size: 1000 },
      ...originParams,
    };
    return request.get(`${apiUrlV1}/promotion/merchandise/`, { params });
  }
  static patch(params) {
    return request.patch(`${apiUrlV1}/promotion/merchandise/`, params);
  }
}

export default MerchandisePromotionService;
